"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUSINESS_COUNTRIES = exports.ExpectedAmountSize = exports.DashboardPaymentStatus = exports.PostMailDeliveryStatus = exports.PaymentStatus = exports.FormStatus = exports.PaymentSort = exports.Sorting = exports.FieldName = exports.DonorType = exports.SortOrder = exports.ContactSort = exports.FormSubmissionStatus = exports.EmailEditorVersion = exports.EmailContentFlow = exports.SuggestedActionType = exports.isEmailEntryPoint = exports.EmailEntryPoint = exports.isEmailEditorOpenedFrom = exports.ViewMyCampaignsButtonClickedFrom = exports.SignupFormEditorOpenedFrom = exports.PostMailEditorOpenedFrom = exports.EmailEditorOpenedFrom = exports.FormCategory = exports.FrequencyFilter = exports.OnboardingStep = exports.isDrawingFormCategory = exports.isTicketingFormCategory = exports.isDonationFormCategory = exports.DonationFormCategory = exports.OrganizationCategory = exports.FiscalYearMonth = exports.OrganizationType = exports.Ratio = exports.OrganizationCause = exports.FormType = exports.TelnyxSetupStatus = exports.ScheduleOffsetUnit = exports.SmsContactStatus = exports.SmsContentType = exports.EmailContentType = exports.SimplykProducts = exports.OnlineAmountRaisedRange = exports.InitialDonorDataProvider = exports.FundraisingCampaignType = exports.InitialEmailProvider = exports.ReferralSource = exports.ReferralQuestionChoice = void 0;
const ticketing_1 = require("./ticketing");
var ReferralQuestionChoice;
(function (ReferralQuestionChoice) {
    ReferralQuestionChoice["ReferralFromOrganization"] = "ReferralFromOrganization";
    ReferralQuestionChoice["ReferralFromDonor"] = "ReferralFromDonor";
    ReferralQuestionChoice["SocialNetwork"] = "SocialNetwork";
    ReferralQuestionChoice["OrganicSearch"] = "OrganicSearch";
    ReferralQuestionChoice["Other"] = "Other";
    ReferralQuestionChoice["Capterra"] = "Capterra";
    ReferralQuestionChoice["AsDonor"] = "AsDonor";
    ReferralQuestionChoice["Nbctc"] = "Nbctc";
})(ReferralQuestionChoice || (exports.ReferralQuestionChoice = ReferralQuestionChoice = {}));
var ReferralSource;
(function (ReferralSource) {
    ReferralSource["Donor"] = "Donor";
    ReferralSource["FriendFamilyColleague"] = "FriendFamilyColleague";
    ReferralSource["SocialMedia"] = "SocialMedia";
    ReferralSource["SearchEngine"] = "SearchEngine";
    ReferralSource["AI"] = "AI";
    ReferralSource["Nbctc"] = "Nbctc";
    ReferralSource["Other"] = "Other";
    ReferralSource["Capterra"] = "Capterra";
    ReferralSource["ReferredByOrganization"] = "ReferredByOrganization";
    ReferralSource["PodcastOrPress"] = "PodcastOrPress";
    ReferralSource["FromDonorDashboard"] = "FromDonorDashboard";
    ReferralSource["FromOrganizationDashboard"] = "FromOrganizationDashboard";
})(ReferralSource || (exports.ReferralSource = ReferralSource = {}));
var InitialEmailProvider;
(function (InitialEmailProvider) {
    InitialEmailProvider["Mailchimp"] = "Mailchimp";
    InitialEmailProvider["ConstantContact"] = "ConstantContact";
    InitialEmailProvider["Gmail"] = "Gmail";
    InitialEmailProvider["Outlook"] = "Outlook";
    InitialEmailProvider["Other"] = "Other";
})(InitialEmailProvider || (exports.InitialEmailProvider = InitialEmailProvider = {}));
var FundraisingCampaignType;
(function (FundraisingCampaignType) {
    FundraisingCampaignType["Donation"] = "Donation";
    FundraisingCampaignType["Event"] = "Event";
    FundraisingCampaignType["Shop"] = "Shop";
    FundraisingCampaignType["Membership"] = "Membership";
    FundraisingCampaignType["Raffle"] = "Raffle";
    FundraisingCampaignType["Auction"] = "Auction";
    FundraisingCampaignType["PeerToPeer"] = "PeerToPeer";
    FundraisingCampaignType["Other"] = "Other";
    FundraisingCampaignType["None"] = "None";
})(FundraisingCampaignType || (exports.FundraisingCampaignType = FundraisingCampaignType = {}));
var InitialDonorDataProvider;
(function (InitialDonorDataProvider) {
    InitialDonorDataProvider["DonorManagementPlatform"] = "DonorManagementPlatform";
    InitialDonorDataProvider["GoogleSheetExcel"] = "GoogleSheetExcel";
    InitialDonorDataProvider["NoProvider"] = "NoProvider";
    InitialDonorDataProvider["Other"] = "Other";
})(InitialDonorDataProvider || (exports.InitialDonorDataProvider = InitialDonorDataProvider = {}));
var OnlineAmountRaisedRange;
(function (OnlineAmountRaisedRange) {
    OnlineAmountRaisedRange["Nothing"] = "Nothing";
    OnlineAmountRaisedRange["LessThan1k"] = "LessThan1k";
    OnlineAmountRaisedRange["From1kTo5k"] = "From1kTo5k";
    OnlineAmountRaisedRange["From5kTo25k"] = "From5kTo25k";
    OnlineAmountRaisedRange["From25kTo100k"] = "From25kTo100k";
    OnlineAmountRaisedRange["MoreThan100k"] = "MoreThan100k";
})(OnlineAmountRaisedRange || (exports.OnlineAmountRaisedRange = OnlineAmountRaisedRange = {}));
var SimplykProducts;
(function (SimplykProducts) {
    SimplykProducts["Donation"] = "Donation";
    SimplykProducts["Ticketing"] = "Ticketing";
})(SimplykProducts || (exports.SimplykProducts = SimplykProducts = {}));
var EmailContentType;
(function (EmailContentType) {
    EmailContentType["INVITATION"] = "invitation";
    EmailContentType["FOLLOW_UP"] = "followup";
    EmailContentType["BLAST"] = "blast";
    EmailContentType["POST_EVENT"] = "post-event";
    EmailContentType["REMINDER"] = "reminder";
    EmailContentType["REMINDER2"] = "reminder2";
    EmailContentType["EXTRA_THANK_YOU_EMAIL"] = "extra_thank_you_email";
    EmailContentType["INCOMPLETE_PAYMENT_FOLLOW_UP"] = "incomplete_payment_followup";
    EmailContentType["THANK_YOU"] = "thank_you";
    EmailContentType["AUCTION_WINNERS"] = "auction_winners";
    EmailContentType["AUCTION_NON_WINNERS"] = "auction_non_winners";
    EmailContentType["OUTBID"] = "outbid";
    EmailContentType["ORDER_SHIPPED"] = "order_shipped";
    EmailContentType["READY_FOR_PICKUP"] = "ready_for_pickup";
    EmailContentType["MEMBERSHIP_EXPIRATION"] = "membership_expiration";
    EmailContentType["MEMBERSHIP_AUTO_RENEWAL"] = "membership_auto_renewal";
    EmailContentType["CRMWORKFLOW"] = "crm_workflow";
})(EmailContentType || (exports.EmailContentType = EmailContentType = {}));
var SmsContentType;
(function (SmsContentType) {
    SmsContentType["OUTBID"] = "outbid";
    SmsContentType["REMINDER"] = "reminder";
    SmsContentType["REMINDER2"] = "reminder2";
})(SmsContentType || (exports.SmsContentType = SmsContentType = {}));
var SmsContactStatus;
(function (SmsContactStatus) {
    SmsContactStatus["None"] = "none";
    SmsContactStatus["Subscribed"] = "subscribed";
    SmsContactStatus["Unsubscribed"] = "unsubscribed";
})(SmsContactStatus || (exports.SmsContactStatus = SmsContactStatus = {}));
var ScheduleOffsetUnit;
(function (ScheduleOffsetUnit) {
    ScheduleOffsetUnit["Days"] = "days";
    ScheduleOffsetUnit["Hours"] = "hours";
})(ScheduleOffsetUnit || (exports.ScheduleOffsetUnit = ScheduleOffsetUnit = {}));
var TelnyxSetupStatus;
(function (TelnyxSetupStatus) {
    TelnyxSetupStatus["Requested"] = "requested";
    TelnyxSetupStatus["VerificationPending"] = "verificationPending";
    TelnyxSetupStatus["NumberAssignmentPending"] = "numberAssignmentPending";
    TelnyxSetupStatus["Active"] = "active";
    TelnyxSetupStatus["Failed"] = "failed";
})(TelnyxSetupStatus || (exports.TelnyxSetupStatus = TelnyxSetupStatus = {}));
var FormType;
(function (FormType) {
    FormType["DonationForm"] = "DonationForm";
    FormType["Ticketing"] = "Ticketing";
})(FormType || (exports.FormType = FormType = {}));
var OrganizationCause;
(function (OrganizationCause) {
    OrganizationCause["Nature"] = "Nature";
    OrganizationCause["Solidarity"] = "Solidarity";
    OrganizationCause["SportAndCulture"] = "SportAndCulture";
    OrganizationCause["Education"] = "Education";
})(OrganizationCause || (exports.OrganizationCause = OrganizationCause = {}));
var Ratio;
(function (Ratio) {
    Ratio[Ratio["Square"] = 0] = "Square";
    Ratio[Ratio["Landscape"] = 1] = "Landscape";
    Ratio[Ratio["Auto"] = 2] = "Auto";
    Ratio[Ratio["Free"] = 3] = "Free";
})(Ratio || (exports.Ratio = Ratio = {}));
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Charity"] = "Charity";
    OrganizationType["Other501C"] = "Other501C";
    OrganizationType["Social"] = "Social";
    OrganizationType["Private"] = "Private";
    OrganizationType["Other"] = "Other";
})(OrganizationType || (exports.OrganizationType = OrganizationType = {}));
var FiscalYearMonth;
(function (FiscalYearMonth) {
    FiscalYearMonth["JANUARY"] = "JANUARY";
    FiscalYearMonth["FEBRUARY"] = "FEBRUARY";
    FiscalYearMonth["MARCH"] = "MARCH";
    FiscalYearMonth["APRIL"] = "APRIL";
    FiscalYearMonth["MAY"] = "MAY";
    FiscalYearMonth["JUNE"] = "JUNE";
    FiscalYearMonth["JULY"] = "JULY";
    FiscalYearMonth["AUGUST"] = "AUGUST";
    FiscalYearMonth["SEPTEMBER"] = "SEPTEMBER";
    FiscalYearMonth["OCTOBER"] = "OCTOBER";
    FiscalYearMonth["NOVEMBER"] = "NOVEMBER";
    FiscalYearMonth["DECEMBER"] = "DECEMBER";
})(FiscalYearMonth || (exports.FiscalYearMonth = FiscalYearMonth = {}));
var OrganizationCategory;
(function (OrganizationCategory) {
    OrganizationCategory["SocialService"] = "SocialService";
    OrganizationCategory["CommunityService"] = "CommunityService";
    OrganizationCategory["SportsAndLeisure"] = "SportsAndLeisure";
    OrganizationCategory["Culture"] = "Culture";
    OrganizationCategory["Health"] = "Health";
    OrganizationCategory["Veterans"] = "Veterans";
    OrganizationCategory["AnimalWelfare"] = "AnimalWelfare";
    OrganizationCategory["Environment"] = "Environment";
    OrganizationCategory["Education"] = "Education";
    OrganizationCategory["StudentGroup"] = "StudentGroup";
    OrganizationCategory["Religion"] = "Religion";
    OrganizationCategory["Humanitarian"] = "Humanitarian";
    OrganizationCategory["Politic"] = "Politic";
    OrganizationCategory["Other"] = "Other";
})(OrganizationCategory || (exports.OrganizationCategory = OrganizationCategory = {}));
var DonationFormCategory;
(function (DonationFormCategory) {
    DonationFormCategory["DonationForm"] = "DonationForm";
    DonationFormCategory["PeerToPeerCampaign"] = "PeerToPeerCampaign";
})(DonationFormCategory || (exports.DonationFormCategory = DonationFormCategory = {}));
const isDonationFormCategory = (category) => {
    if (typeof category !== "string") {
        return false;
    }
    return Object.values(DonationFormCategory).includes(category);
};
exports.isDonationFormCategory = isDonationFormCategory;
const isTicketingFormCategory = (category) => {
    if (typeof category !== "string") {
        return false;
    }
    return Object.values(ticketing_1.TicketingFormCategory).includes(category);
};
exports.isTicketingFormCategory = isTicketingFormCategory;
const isDrawingFormCategory = (category) => category === ticketing_1.TicketingFormCategory.Lottery || category === ticketing_1.TicketingFormCategory.Sweepstakes;
exports.isDrawingFormCategory = isDrawingFormCategory;
var OnboardingStep;
(function (OnboardingStep) {
    /** User created their org but hasn't answered qualification questions yet */
    OnboardingStep["Qualification"] = "qualification";
    /** Qualification done, user needs to pick the type of their first form */
    OnboardingStep["ServiceEntry"] = "service_entry";
    /** Form type chosen, user is editing a draft form (donation or ticketing) */
    OnboardingStep["FormCreation"] = "form_creation";
    /** First form activated — onboarding complete */
    OnboardingStep["Finished"] = "finished";
})(OnboardingStep || (exports.OnboardingStep = OnboardingStep = {}));
var FrequencyFilter;
(function (FrequencyFilter) {
    FrequencyFilter["Daily"] = "Daily";
    FrequencyFilter["Weekly"] = "Weekly";
    FrequencyFilter["Monthly"] = "Monthly";
})(FrequencyFilter || (exports.FrequencyFilter = FrequencyFilter = {}));
exports.FormCategory = { ...ticketing_1.TicketingFormCategory, ...DonationFormCategory };
/** @deprecated Read-only history — kept only as the value type for EMAIL_ENTRY_POINT_TO_LEGACY_OPENED_FROM. Use EmailEntryPoint. */
var EmailEditorOpenedFrom;
(function (EmailEditorOpenedFrom) {
    EmailEditorOpenedFrom["DuplicateFromTableRow"] = "DuplicateFromTableRow";
    EmailEditorOpenedFrom["DuplicateFromDrawer"] = "DuplicateFromDrawer";
    EmailEditorOpenedFrom["DuplicateFromCommunicationTab"] = "DuplicateFromCommunicationTab";
    EmailEditorOpenedFrom["ContactPageHeader"] = "ContactPageHeader";
    EmailEditorOpenedFrom["ContactPageEmailRow"] = "ContactPageEmailRow";
    EmailEditorOpenedFrom["CopyEmailInfobox"] = "CopyEmailInfobox";
    EmailEditorOpenedFrom["EmailTemplateWrapper"] = "EmailTemplateWrapper";
    EmailEditorOpenedFrom["ContactPageBulkHeader"] = "ContactPageBulkHeader";
    EmailEditorOpenedFrom["ContactListBulkHeader"] = "ContactListBulkHeader";
    EmailEditorOpenedFrom["CompanyPageBulkHeader"] = "CompanyPageBulkHeader";
    EmailEditorOpenedFrom["HouseholdPageBulkHeader"] = "HouseholdPageBulkHeader";
    EmailEditorOpenedFrom["CampaignFormsHeader"] = "CampaignFormsHeader";
    EmailEditorOpenedFrom["UserPageHeader"] = "UserPageHeader";
    EmailEditorOpenedFrom["EmailsHeader"] = "EmailsHeader";
    EmailEditorOpenedFrom["GuestListBulkHeader"] = "GuestListBulkHeader";
    EmailEditorOpenedFrom["MembersPageBulkHeader"] = "MembersPageBulkHeader";
    EmailEditorOpenedFrom["VisitorReport"] = "VisitorReport";
    EmailEditorOpenedFrom["EventCommunication"] = "EventCommunication";
    EmailEditorOpenedFrom["PaymentDetailDrawer"] = "PaymentDetailDrawer";
    EmailEditorOpenedFrom["EventCommunicationShortcut"] = "EventCommunicationShortcut";
    EmailEditorOpenedFrom["PaymentPageCampaignHubBulkHeader"] = "PaymentPageCampaignHubBulkHeader";
    EmailEditorOpenedFrom["CampaignTodo"] = "CampaignTodo";
    EmailEditorOpenedFrom["DefaultReminder"] = "DefaultReminder";
    EmailEditorOpenedFrom["ContactListCard"] = "ContactListCard";
    EmailEditorOpenedFrom["FollowupFromEmailDetails"] = "FollowupFromEmailDetails";
    EmailEditorOpenedFrom["EmailListEmptyState"] = "EmailListEmptyState";
    EmailEditorOpenedFrom["InviteGuestsEmptyState"] = "InviteGuestsEmptyState";
    EmailEditorOpenedFrom["CommsTabEmptyState"] = "CommsTabEmptyState";
    EmailEditorOpenedFrom["CampaignHubPaymentsTableEmptyState"] = "CampaignHubPaymentsTableEmptyState";
    EmailEditorOpenedFrom["BackToTemplateDialog"] = "BackToTemplateDialog";
    EmailEditorOpenedFrom["AmplitudeFeatureAnnouncement"] = "AmplitudeFeatureAnnouncement";
    EmailEditorOpenedFrom["CrossSell"] = "CrossSell";
    EmailEditorOpenedFrom["CrmWorkflowStep"] = "CrmWorkflowStep";
})(EmailEditorOpenedFrom || (exports.EmailEditorOpenedFrom = EmailEditorOpenedFrom = {}));
var PostMailEditorOpenedFrom;
(function (PostMailEditorOpenedFrom) {
    PostMailEditorOpenedFrom["PostMailListEmptyState"] = "PostMailListEmptyState";
    PostMailEditorOpenedFrom["CommunicationsPageMainNavigationButton"] = "CommunicationsPageMainNavigationButton";
    PostMailEditorOpenedFrom["EndOfYearChecklist"] = "EndOfYearChecklist";
})(PostMailEditorOpenedFrom || (exports.PostMailEditorOpenedFrom = PostMailEditorOpenedFrom = {}));
var SignupFormEditorOpenedFrom;
(function (SignupFormEditorOpenedFrom) {
    SignupFormEditorOpenedFrom["SignupFormListEmptyState"] = "SignupFormListEmptyState";
    SignupFormEditorOpenedFrom["CRMPageMainNavigationButton"] = "CRMPageMainNavigationButton";
    SignupFormEditorOpenedFrom["ServiceEntry"] = "ServiceEntry";
    SignupFormEditorOpenedFrom["OrganizationAssistant"] = "OrganizationAssistant";
})(SignupFormEditorOpenedFrom || (exports.SignupFormEditorOpenedFrom = SignupFormEditorOpenedFrom = {}));
var ViewMyCampaignsButtonClickedFrom;
(function (ViewMyCampaignsButtonClickedFrom) {
    ViewMyCampaignsButtonClickedFrom["PaymentsTableEmptyState"] = "PaymentsTableEmptyState";
    ViewMyCampaignsButtonClickedFrom["CampaignHubPaymentsTableEmptyState"] = "CampaignHubPaymentsTableEmptyState";
    ViewMyCampaignsButtonClickedFrom["PayoutsTableEmptyState"] = "PayoutsTableEmptyState";
    ViewMyCampaignsButtonClickedFrom["ReceiptsTableEmptyState"] = "ReceiptsTableEmptyState";
})(ViewMyCampaignsButtonClickedFrom || (exports.ViewMyCampaignsButtonClickedFrom = ViewMyCampaignsButtonClickedFrom = {}));
const isEmailEditorOpenedFrom = (value) => Object.values(EmailEditorOpenedFrom).includes(value);
exports.isEmailEditorOpenedFrom = isEmailEditorOpenedFrom;
var EmailEntryPoint;
(function (EmailEntryPoint) {
    EmailEntryPoint["CampaignHubBanners"] = "CampaignHubBanners";
    EmailEntryPoint["EndOfYearChecklistLapsedDonor"] = "EndOfYearChecklistLapsedDonor";
    EmailEntryPoint["EndOfYearChecklistLastChance"] = "EndOfYearChecklistLastChance";
    EmailEntryPoint["CampaignHubEmailGuestsButton"] = "CampaignHubEmailGuestsButton";
    EmailEntryPoint["CampaignHubEmailDonorsButton"] = "CampaignHubEmailDonorsButton";
    EmailEntryPoint["CampaignHubEmailMembersButton"] = "CampaignHubEmailMembersButton";
    EmailEntryPoint["CampaignHubEmailBiddersButton"] = "CampaignHubEmailBiddersButton";
    EmailEntryPoint["CampaignHubEmailBuyersButton"] = "CampaignHubEmailBuyersButton";
    EmailEntryPoint["CampaignHubEmailOrganizersButton"] = "CampaignHubEmailOrganizersButton";
    EmailEntryPoint["CampaignHubGuestListBulkEmail"] = "CampaignHubGuestListBulkEmail";
    EmailEntryPoint["CampaignHubFulfillmentBulkEmail"] = "CampaignHubFulfillmentBulkEmail";
    EmailEntryPoint["CampaignHubPaymentsBulkEmail"] = "CampaignHubPaymentsBulkEmail";
    EmailEntryPoint["PaymentsPageBulkEmail"] = "PaymentsPageBulkEmail";
    EmailEntryPoint["CampaignHubCommunicationTab"] = "CampaignHubCommunicationTab";
    EmailEntryPoint["ShareFormModalInvitationLink"] = "ShareFormModalInvitationLink";
    EmailEntryPoint["CampaignHubGuestListEmptyState"] = "CampaignHubGuestListEmptyState";
    EmailEntryPoint["CampaignHubPaymentsEmptyState"] = "CampaignHubPaymentsEmptyState";
    EmailEntryPoint["EmailsPageEmptyState"] = "EmailsPageEmptyState";
    EmailEntryPoint["EmailsPageNewEmailButton"] = "EmailsPageNewEmailButton";
    EmailEntryPoint["EmailDetailsNewEmailButton"] = "EmailDetailsNewEmailButton";
    EmailEntryPoint["PaymentDrawerThankYouButton"] = "PaymentDrawerThankYouButton";
    EmailEntryPoint["CampaignHubPaymentsThankYouCell"] = "CampaignHubPaymentsThankYouCell";
    EmailEntryPoint["PaymentsPageThankYouCell"] = "PaymentsPageThankYouCell";
    EmailEntryPoint["CopyEmailPopoverButton"] = "CopyEmailPopoverButton";
    EmailEntryPoint["ContactDrawerHeaderButton"] = "ContactDrawerHeaderButton";
    EmailEntryPoint["ContactsPageRowEmail"] = "ContactsPageRowEmail";
    EmailEntryPoint["ContactsPageBulkEmail"] = "ContactsPageBulkEmail";
    EmailEntryPoint["ListsPageCardMenuEmail"] = "ListsPageCardMenuEmail";
    EmailEntryPoint["ListPageBulkEmail"] = "ListPageBulkEmail";
    EmailEntryPoint["MembersPageBulkEmail"] = "MembersPageBulkEmail";
    EmailEntryPoint["MembersPageRowEmail"] = "MembersPageRowEmail";
    EmailEntryPoint["CompaniesPageBulkEmail"] = "CompaniesPageBulkEmail";
    EmailEntryPoint["CompanyDrawerHeaderButton"] = "CompanyDrawerHeaderButton";
    EmailEntryPoint["HouseholdDrawerHeaderButton"] = "HouseholdDrawerHeaderButton";
    EmailEntryPoint["EmailsPageRowDuplicate"] = "EmailsPageRowDuplicate";
    EmailEntryPoint["CampaignHubCommunicationDuplicate"] = "CampaignHubCommunicationDuplicate";
    EmailEntryPoint["EmailDetailsDuplicate"] = "EmailDetailsDuplicate";
    EmailEntryPoint["ContactDrawerActivityDuplicate"] = "ContactDrawerActivityDuplicate";
    EmailEntryPoint["EmailDetailsFollowUpButton"] = "EmailDetailsFollowUpButton";
    EmailEntryPoint["CrossSellNewsletterPrompt"] = "CrossSellNewsletterPrompt";
    EmailEntryPoint["FeatureAnnouncementDeepLink"] = "FeatureAnnouncementDeepLink";
    EmailEntryPoint["SystemVisitorReport"] = "SystemVisitorReport";
    EmailEntryPoint["SystemDefaultReminder"] = "SystemDefaultReminder";
    EmailEntryPoint["SystemAutomatedFormEmail"] = "SystemAutomatedFormEmail";
})(EmailEntryPoint || (exports.EmailEntryPoint = EmailEntryPoint = {}));
const isEmailEntryPoint = (value) => Object.values(EmailEntryPoint).includes(value);
exports.isEmailEntryPoint = isEmailEntryPoint;
var SuggestedActionType;
(function (SuggestedActionType) {
    SuggestedActionType["Visitor"] = "Visitor";
    SuggestedActionType["TaxReceipt"] = "TaxReceipt";
    SuggestedActionType["ThankBigDonor"] = "ThankBigDonor";
    SuggestedActionType["Import"] = "Import";
    SuggestedActionType["AddUser"] = "AddUser";
    SuggestedActionType["TapToPay"] = "TapToPay";
    SuggestedActionType["FormCommunicationSetup"] = "FormCommunicationSetup";
})(SuggestedActionType || (exports.SuggestedActionType = SuggestedActionType = {}));
var EmailContentFlow;
(function (EmailContentFlow) {
    /** @deprecated - already phased out, db will be cleaned up soon  */
    EmailContentFlow["Custom"] = "Custom";
    EmailContentFlow["Quick"] = "Quick";
    EmailContentFlow["Builder"] = "Builder";
    EmailContentFlow["FormEditor"] = "FormEditor";
})(EmailContentFlow || (exports.EmailContentFlow = EmailContentFlow = {}));
var EmailEditorVersion;
(function (EmailEditorVersion) {
    EmailEditorVersion["Unlayer"] = "unlayer";
    EmailEditorVersion["Waypoint"] = "waypoint";
})(EmailEditorVersion || (exports.EmailEditorVersion = EmailEditorVersion = {}));
var FormSubmissionStatus;
(function (FormSubmissionStatus) {
    FormSubmissionStatus["Incomplete"] = "Incomplete";
    FormSubmissionStatus["Failed"] = "Failed";
    FormSubmissionStatus["Succeeded"] = "Succeeded";
})(FormSubmissionStatus || (exports.FormSubmissionStatus = FormSubmissionStatus = {}));
var ContactSort;
(function (ContactSort) {
    ContactSort["LastName"] = "lower_last_name";
    ContactSort["LastTransactionDate"] = "contact.lastInteractionCreatedAt";
    ContactSort["TotalContribution"] = "contact.totalContribution";
})(ContactSort || (exports.ContactSort = ContactSort = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
var DonorType;
(function (DonorType) {
    DonorType["Monthly"] = "Monthly";
    DonorType["Member"] = "Member";
    DonorType["Yearly"] = "Yearly";
    DonorType["Returning"] = "Returning";
    DonorType["OneTime"] = "OneTime";
    DonorType["Prospect"] = "Prospect";
})(DonorType || (exports.DonorType = DonorType = {}));
/*
  This enum is here to control the value of fieldName that is sent by the client
  We can avoid SQL injections that way since the fieldName cannot be passed as a parameter to the query
  Make sure that this value corresponds to a field alias in the corresponding typeorm query
*/
var FieldName;
(function (FieldName) {
    FieldName["ContactTableUserId"] = "user.id";
    FieldName["ContactTableLanguage"] = "contact.locale";
    FieldName["ContactTableEmail"] = "user.email";
    FieldName["ContactTableLastPaymentDate"] = "contact.lastInteractionCreatedAt";
    FieldName["ContactTableFirstPaymentDate"] = "contact.firstInteractionCreatedAt";
    FieldName["ContactTableTotalContribution"] = "contact.totalContribution";
    FieldName["ContactTableDonorType"] = "contact.donorType";
    FieldName["ContactTableCompleteName"] = "contact.fullname";
    FieldName["ContactTableCompanyName"] = "commands.corporationName";
    FieldName["ContactTableFormId"] = "commands.formId";
    FieldName["ContactTableTransactionDate"] = "transactions.createdAtUtc";
    FieldName["ContactTableMonthlyDonation"] = "subscriptions.status";
    FieldName["ContactTableRecurringPayment"] = "subscriptions.recurrenceInterval";
    FieldName["ContactTableNoteContent"] = "notes.content";
    FieldName["TicketingTableIsArchived"] = "ticketing.is_archived";
    FieldName["DonationFormTableIsArchived"] = "donation_form.is_archived";
    FieldName["DonationFormTableCategory"] = "donation_form.category";
    FieldName["DonationFormTableCreatedAtUtc"] = "donation_form.created_at_utc";
    FieldName["DonationFormTableUrlPath"] = "donation_form.url_path";
    FieldName["DonationFormTableTarget"] = "donation_form.target";
    FieldName["OrderTableCreateAtUtc"] = "order.created_at_utc";
    FieldName["OrderTableTicketingId"] = "order.ticketing_id";
    FieldName["OrderTableOccurrenceId"] = "order.occurrence_id";
    FieldName["OrderTableLocale"] = "order.locale";
    FieldName["OrderTableFirstName"] = "order.first_name";
    FieldName["OrderTableLastName"] = "order.last_name";
    FieldName["OrderTableEmail"] = "order.email";
    FieldName["OrderTableHasUnsubscribed"] = "contacts.hasUnsubscribed";
    FieldName["EmailDeliveryStatus"] = "email_deliveries.status";
    FieldName["EmailContentEditorVersion"] = "email_content.editor_version";
    FieldName["EmailContentFlow"] = "email_content.flow";
    FieldName["CommandTableStatus"] = "command.status";
    FieldName["CommandTableCreatedAtUtc"] = "command.created_at_utc";
    FieldName["ReceiptTableCreatedAtUtc"] = "receipt.created_at_utc";
    FieldName["ReceiptTableDonationDate"] = "receipt.donation_date";
    FieldName["ReceiptTableFirstName"] = "receipt.first_name";
    FieldName["ReceiptTableLastName"] = "receipt.last_name";
    FieldName["ReceiptTableEmail"] = "receipt.email";
    FieldName["ReceiptTableStatus"] = "receipt.status";
    FieldName["AnswersAnswer"] = "answers.answer";
    FieldName["TransactionTableCreatedAtUtc"] = "transaction.created_at_utc";
    FieldName["TransactionTableFirstName"] = "command.first_name";
    FieldName["TransactionTableLastName"] = "command.last_name";
    FieldName["TransactionTableEmail"] = "command.email";
    FieldName["TransactionTableFormId"] = "command.form_id";
    FieldName["ProductTicketAnnotation"] = "product_tickets.annotation";
    FieldName["TransactionTableOccurrence"] = "command.ticketing_occurrence_id";
    FieldName["TransactionTableProductTicketStatus"] = "product_tickets.status";
    FieldName["TransactionTableHasUnsubscribe"] = "has_unsubscribed";
    FieldName["TransactionTableLocale"] = "command.locale";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    FieldName["InsightsPageTransactionCreatedAtUtc"] = "transaction.created_at_utc";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    FieldName["InsightsPageFormId"] = "command.form_id";
    FieldName["VisitorTableUserID"] = "command.user_id";
    FieldName["EventManagementTableCommandId"] = "command.id";
    FieldName["TicketStatus"] = "TicketStatus";
    FieldName["GuestListTableRate"] = "product_tickets.rate_id";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    FieldName["ProductTicketStatus"] = "product_tickets.status";
    FieldName["ReminderEmailStatus"] = "reminder_email.status";
})(FieldName || (exports.FieldName = FieldName = {}));
var Sorting;
(function (Sorting) {
    Sorting["TitleAsc"] = "TitleAsc";
    Sorting["TitleDesc"] = "TitleDesc";
    Sorting["VolumeAsc"] = "VolumeAsc";
    Sorting["VolumeDesc"] = "VolumeDesc";
    Sorting["CreationDateDesc"] = "CreationDateDesc";
    Sorting["UpdatedDateDesc"] = "UpdatedDateDesc";
})(Sorting || (exports.Sorting = Sorting = {}));
var PaymentSort;
(function (PaymentSort) {
    PaymentSort["Amount"] = "transferrable_amount";
    PaymentSort["Date"] = "transaction.created_at_utc";
    PaymentSort["PurchaserLastName"] = "lower_purchaser_last_name";
})(PaymentSort || (exports.PaymentSort = PaymentSort = {}));
var FormStatus;
(function (FormStatus) {
    FormStatus["Draft"] = "draft";
    FormStatus["Active"] = "active";
})(FormStatus || (exports.FormStatus = FormStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Created"] = "created";
    PaymentStatus["Processing"] = "processing";
    PaymentStatus["Succeeded"] = "succeeded";
    /** @deprecated */
    PaymentStatus["AwaitingTransfer"] = "awaiting_transfer";
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Expired"] = "expired";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var PostMailDeliveryStatus;
(function (PostMailDeliveryStatus) {
    PostMailDeliveryStatus["Draft"] = "draft";
    PostMailDeliveryStatus["Processing"] = "processing";
    PostMailDeliveryStatus["Sent"] = "sent";
    PostMailDeliveryStatus["Failed"] = "failed";
})(PostMailDeliveryStatus || (exports.PostMailDeliveryStatus = PostMailDeliveryStatus = {}));
var DashboardPaymentStatus;
(function (DashboardPaymentStatus) {
    DashboardPaymentStatus["ToConfirm"] = "ToConfirm";
    DashboardPaymentStatus["Due"] = "Due";
    DashboardPaymentStatus["Processing"] = "Processing";
    DashboardPaymentStatus["Succeeded"] = "Succeeded";
    DashboardPaymentStatus["Failed"] = "Failed";
    DashboardPaymentStatus["Disputed"] = "Disputed";
    DashboardPaymentStatus["DisputeLost"] = "DisputeLost";
    DashboardPaymentStatus["Weekly"] = "Weekly";
    DashboardPaymentStatus["BiWeekly"] = "BiWeekly";
    DashboardPaymentStatus["Monthly"] = "Monthly";
    DashboardPaymentStatus["Quarterly"] = "Quarterly";
    DashboardPaymentStatus["Yearly"] = "Yearly";
    DashboardPaymentStatus["Stopped"] = "Stopped";
    DashboardPaymentStatus["PastDue"] = "PastDue";
    DashboardPaymentStatus["Unprocessed"] = "Unprocessed";
    DashboardPaymentStatus["Incomplete"] = "Incomplete";
    DashboardPaymentStatus["OnHold"] = "OnHold";
})(DashboardPaymentStatus || (exports.DashboardPaymentStatus = DashboardPaymentStatus = {}));
var ExpectedAmountSize;
(function (ExpectedAmountSize) {
    ExpectedAmountSize["Small"] = "Small";
    ExpectedAmountSize["Medium"] = "Medium";
    ExpectedAmountSize["Big"] = "Big";
})(ExpectedAmountSize || (exports.ExpectedAmountSize = ExpectedAmountSize = {}));
exports.BUSINESS_COUNTRIES = ["US", "CA", "PR", "FR", "GB", "AU"];
